import {createContext, useContext} from 'react';

const PlanningTableReserveContext = createContext(0);

export const PlanningTableReserveProvider = PlanningTableReserveContext.Provider;

export const usePlanningTableReserveRight = () => useContext(PlanningTableReserveContext);
